<template>
  <v-card>
    <v-form @submit.prevent="submitAddTip()" ref="addTipForm">
      <v-card-title>
        <span class="headline">Add Tip {{isRequest || tip.request ? 'Request' : ''}}</span>
      </v-card-title>
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field
              label="* Name"
              v-model="tip.name"
              :rules="nameRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Tip Number"
              v-model="tip.number"
              :rules="numberRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Contact Email"
              v-model="tip.contactEmail"
              :rules="contactEmailRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Details"
              v-model="tip.details"
              :rules="detailsRules"
              :color="primaryNeutral"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-switch
              label="Tipping docket required?"
              v-model="tip.tippingDocketRequired"
              :color="primaryNeutral"
            ></v-switch>
            <v-switch
              label="Weigh Bridge?"
              v-model="tip.weighBridge"
              :color="primaryNeutral"
              class="mt-0"
            ></v-switch>
            <v-switch label="Request" v-model="tip.request" class="mt-0" v-if="!isRequest"></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn
          :color="primaryNeutral"
          flat
          type="submit"
          :loading="addingTip"
        >{{ isRequest || tip.request ? 'Create Request' : 'Add'}}</v-btn>
      </v-card-actions>
    </v-form>

    <select-spoils
      v-model="tip.selectedSpoils"
      :items="spoils"
      title="Allowed Spoils"
      route="spoil"
    ></select-spoils>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import TipService from '@/services/requests/tipService'
import TipValidation from '@/services/validation/tipValidation'

import getSpoils from '@/services/mixins/getMasterFiles/getSpoils'
import SelectSpoils from '@/components/ui/selectTipSpoils'
export default {
  components: {
    SelectSpoils,
  },
  mixins: [getSpoils, TipValidation],
  props: {
    isRequest: Boolean,
  },
  data() {
    return {
      tip: {
        name: '',
        number: '',
        contactEmail: '',
        details: '',
        tippingDocketRequired: false,
        weighBridge: false,
        selectedSpoils: [],
        request: false,
      },
      contractors: [],
      addingTip: false,
      loadingContractors: false,
    }
  },
  methods: {
    submitAddTip() {
      if (!this.$refs.addTipForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      if (!this.tip.selectedSpoils.length) {
        this.snack({ text: 'Please select 1 or more spoil', color: 'red' })
        return
      }
      this.addTip()
    },
    addTip() {
      this.loading = true
      if (this.isRequest) this.tip.request = this.isRequest
      TipService.addTip(this.tip)
        .then((result) => {
          this.loading = false
          this.$store.commit('tips/addToArrayState', {
            prop: 'tips',
            value: result.data.result,
          })
          this.resetForm()
          this.snack({ color: 'green', text: 'Tip was added' })
          this.close()
        })
        .catch((err) => {
          this.snackError()
          this.addingTip = false
          console.log(err)
        })
    },
    resetForm() {
      this.tip.name = ''
      this.tip.contactEmail = ''
      this.tip.details = ''
      this.tip.selectedSpoils = []
      this.tip.tippingDocketRequired = false
      this.$refs.addTipForm.resetValidation()
    },
    close() {
      this.$emit('close')
    },
  },
  mounted() {},
}
</script>

<style>
</style>
